import { CheckCircle2, XCircle } from "lucide-react";
import { Logo } from "../components/Logo";

export default function InvoicePaymentResultPage({ paid }) {
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center gap-6 px-5 text-center">
      <Logo markSize={34} textSize="text-2xl" />
      {paid ? (
        <>
          <CheckCircle2 size={48} className="text-tea-text" />
          <div>
            <h1 className="font-heading font-bold text-2xl">Payment received</h1>
            <p className="text-ink/60 mt-2 text-sm">Thanks, your payment has gone through.</p>
          </div>
        </>
      ) : (
        <>
          <XCircle size={48} className="text-ink/30" />
          <div>
            <h1 className="font-heading font-bold text-2xl">Payment not completed</h1>
            <p className="text-ink/60 mt-2 text-sm">You can ask for a new payment link whenever you're ready.</p>
          </div>
        </>
      )}
    </div>
  );
}
